import { inject, Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Market } from "../types/bet.type";
import { environment } from "../../environments/environment";
import { BehaviorSubject, Subscription } from "rxjs";
import { ApiService } from "./api.service";
import { HttpClient } from "@angular/common/http";

type MarketConfig = { DESCRIPTION: string; IS_ACTIVE: boolean; NAME: string };

@Injectable({
  providedIn: "root",
})
export class WhiteLabelConfigService {
  http = inject(HttpClient);
  apiService = inject(ApiService);
  subscriptions: Subscription = new Subscription();
  marketConfig$ = new BehaviorSubject<Record<string, any>>({});

  constructor(@Inject(DOCUMENT) private document: Document) {}

  get whiteLabelId() {
    return this.apiService.getUserToken()?.user?.DOMAIN_ID;
  }

  get permissions() {
    return this.apiService.getUserToken()?.user?.PERMISSIONS;
  }

  updateFavicon(faviconPath: string): void {
    let link: HTMLLinkElement = this.document.querySelector("link[rel*='icon']") || this.document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = faviconPath;
    this.document.getElementsByTagName("head")[0].appendChild(link);
  }

  updateTitle(title: string): void {
    this.document.title = title;
  }

  showLayBet(market: Market) {
    const eventType = String(market?.eventType?.id);
    const isGreyhound = ["2147483999", "4339"].includes(eventType);
    const isHorseRacing = ["2147483666", "7"].includes(eventType);

    if (isGreyhound) return this.showFeature("greyHoundRacingLayBet");
    if (isHorseRacing) return this.showFeature("horseRacingLayBet");
    return true;
  }

  showFeature(permission: string) {
    return this.permissions.includes(permission);
  }

  fetchWlMarketConfig() {
    this.subscriptions.add(
      this.http.get(`${environment.sURL}${environment.endpoints.wlMarketConfig}/${this.whiteLabelId}`).subscribe({
        next: (response: any) => {
          const result: MarketConfig[] = response?.result;
          if (result) {
            const config = result?.reduce(
              (acc, item) => {
                acc[item.NAME] = item.IS_ACTIVE;
                return acc;
              },
              {} as Record<string, boolean>,
            );
            this.marketConfig$.next({ ...config, PRE_MATCH_PLACEMENT: true, UPDATE_UNMATCHED_BET: true, LINE_MARKET: true });
          }
        },
      }),
    );
  }

  isWithin45Minutes(marketStartTime: string): boolean {
    const eventTime = new Date(marketStartTime).getTime();
    const now = Date.now();

    const diffInMs = eventTime - now;
    const diffInMinutes = diffInMs / (1000 * 60);

    return diffInMinutes <= 45;
  }
}
